import type { Entity as WorkbookEntity } from '~/@entities/(Content)/Workbook/dto'
import type {
  AllGradeSubject,
  Revision,
  SchoolType,
  Semester,
} from '~/@entities/SchoolSystem/schema'

import type { PodProductApi } from './api'
import type { ProductStatus } from './constant'
import type { ProductType } from './type'

export namespace Entity {
  export class SignatureWorkbookProduct {
    id: number
    type: ProductType
    name: string
    description: string
    detailImageUrl: string

    workbookId: number
    revision: Revision
    schoolType: SchoolType
    grade: AllGradeSubject
    semester: Semester
    pairFlag: boolean
    autoScored: boolean
    signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType']

    constructor(data: SignatureWorkbookProduct) {
      this.id = data.id
      this.type = data.type
      this.name = data.name
      this.description = data.description
      this.detailImageUrl = data.detailImageUrl
      this.workbookId = data.workbookId
      this.revision = data.revision
      this.schoolType = data.schoolType
      this.grade = data.grade
      this.semester = data.semester
      this.pairFlag = data.pairFlag
      this.autoScored = data.autoScored
      this.signatureType = data.signatureType
    }
  }

  export class CustomWorkbookProduct {
    id: number
    type: ProductType
    name: string
    description: string
    detailImageUrl: string
    status: ProductStatus
    colorPagePrice: number
    bwPagePrice: number
    bwPageSupplyPrice: number
    problemColorPricePerPage: number
    colorPageSupplyPrice: number
    coverSupplyPrice: number
    problemBwPricePerPage: number
    minPageNumber: number
    maxPageNumber: number

    constructor(data: CustomWorkbookProduct) {
      this.id = data.id
      this.type = data.type
      this.name = data.name
      this.description = data.description
      this.detailImageUrl = data.detailImageUrl
      this.status = data.status
      this.colorPagePrice = data.colorPagePrice
      this.bwPagePrice = data.bwPagePrice
      this.bwPageSupplyPrice = data.bwPageSupplyPrice
      this.problemColorPricePerPage = data.problemColorPricePerPage
      this.colorPageSupplyPrice = data.colorPageSupplyPrice
      this.coverSupplyPrice = data.coverSupplyPrice
      this.problemBwPricePerPage = data.problemBwPricePerPage
      this.minPageNumber = data.minPageNumber
      this.maxPageNumber = data.maxPageNumber
    }
  }

  export class PrintDocumentProduct extends CustomWorkbookProduct {
    override type: 'PRINT_DOCUMENT'
    coverPrice: PodProductApi.Response.PrintDocumentProduct['coverPrice']

    constructor(data: PrintDocumentProduct) {
      super(data)
      this.type = 'PRINT_DOCUMENT'
      this.coverPrice = data.coverPrice
    }
  }

  export class KMMProduct {
    id: number
    type: ProductType
    name: string
    description: string
    imageUrl: string
    detailImageUrl: string
    status: 'ACTIVE' | 'INACTIVE'
    productDiscountRate: number
    round: number
    awardProductType: 'BANNER' | 'BANNER_STAND' | 'CERTIFICATE'
    awardProductPrice: number
    deliveryPrice: number
    academyContactName: string | null
    academyContactPhoneNumber: string | null
    orderingNumber: number = -1

    constructor(data: KMMProduct) {
      this.id = data.id
      this.type = data.type
      this.name = data.name
      this.description = data.description
      this.imageUrl = data.imageUrl
      this.detailImageUrl = data.detailImageUrl
      this.status = data.status
      this.productDiscountRate = data.productDiscountRate
      this.round = data.round
      this.awardProductType = data.awardProductType
      this.awardProductPrice = data.awardProductPrice
      this.deliveryPrice = data.deliveryPrice
      this.academyContactName = data.academyContactName
      this.academyContactPhoneNumber = data.academyContactPhoneNumber
      this.orderingNumber = data.orderingNumber
    }
  }

  export type Product =
    | SignatureWorkbookProduct
    | CustomWorkbookProduct
    | PrintDocumentProduct
    | KMMProduct
}
